export const IMAGES = {
  serverRoom:
    "https://images.unsplash.com/photo-1768885511941-a9a39d0a88ae?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxjeWJlcnNlY3VyaXR5JTIwc2VydmVyJTIwcm9vbSUyMGRhcmslMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4ODgzODQwMHww&ixlib=rb-4.1.0&q=85&w=1920&auto=format",
  codeScreens:
    "https://images.unsplash.com/photo-1754039984985-ef607d80113a?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwc2VydmVyJTIwcm9vbSUyMGRhcmslMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4ODgzODQwMHww&ixlib=rb-4.1.0&q=85&w=1920&auto=format",
  socCenter:
    "https://images.unsplash.com/photo-1708807472445-d33589e6b090?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMFNPQyUyMHNlY3VyaXR5JTIwb3BlcmF0aW9uc3xlbnwwfHx8fDE3ODg4Mzg0MDB8MA&ixlib=rb-4.1.0&q=85&w=1920&auto=format",
  matrix:
    "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwc2VjdXJpdHklMjBkYXRhJTIwc2NyZWVuJTIwY29kZXxlbnwwfHx8fDE3ODg4Mzg0MDB8MA&ixlib=rb-4.1.0&q=85&w=1920&auto=format",
  dashboard:
    "https://images.unsplash.com/photo-1751448555253-f39c06e29d82?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMFNPQyUyMHNlY3VyaXR5JTIwb3BlcmF0aW9uc3xlbnwwfHx8fDE3ODg4Mzg0MDB8MA&ixlib=rb-4.1.0&q=85&w=1920&auto=format",
  padlock:
    "https://images.unsplash.com/photo-1614064548237-096f735f344f?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29yayUyMFNPQyUyMHNlY3VyaXR5JTIwb3BlcmF0aW9uc3xlbnwwfHx8fDE3ODg4Mzg0MDB8MA&ixlib=rb-4.1.0&q=85&w=1920&auto=format",
  skyline:
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=webp&q=85&w=1600&auto=format",
};

export const CONTACT = {
  email: "business@lanvaus.com",
  phones: [
    { label: "US / International", value: "+1 518 512 9460", href: "tel:+15185129460" },
    { label: "India", value: "+91 81858 22663", href: "tel:+918185822663" },
  ],
  addressLines: [
    "Lanvaus Private Limited",
    "Flat No. 201, H.No. 2-1-336,",
    "Sriram Nagar Colony, Nagole,",
    "Hyderabad 500068, Telangana, India",
  ],
  location: "Flat No. 201, H.No. 2-1-336, Sriram Nagar Colony, Nagole, Hyderabad 500068, Telangana, India",
};

export const CERTIFICATIONS = [
  { short: "OSCP", full: "Offensive Security Certified Professional — hands-on exploitation and penetration testing" },
  { short: "CISSP", full: "Certified Information Systems Security Professional — security architecture and governance" },
  { short: "CEH", full: "Certified Ethical Hacker — offensive tooling and methodology" },
  { short: "CISA", full: "Certified Information Systems Auditor — IS audit, control and assurance" },
  { short: "ISO 27001 Lead Auditor", full: "ISMS design, implementation and audit against ISO/IEC 27001" },
  { short: "AWS & Azure Security", full: "Cloud security specialty certifications across AWS and Microsoft Azure" },
];

export const TRUST_COMMITMENTS = [
  {
    icon: "FileLock2",
    title: "NDA before scoping",
    copy: "We sign your NDA, or ours, before any technical discussion. Scoping calls do not require you to disclose architecture in the clear.",
  },
  {
    icon: "UserCheck",
    title: "Named, certified engineers",
    copy: "You are told which engineers will run the engagement and what they hold. No unnamed offshore bench, no bait-and-switch after the SOW is signed.",
  },
  {
    icon: "ShieldCheck",
    title: "Least-privilege access",
    copy: "We request the minimum access needed, time-bound and revocable. Access is logged and handed back in writing at the end of the engagement.",
  },
  {
    icon: "HardDriveDownload",
    title: "Evidence handling and deletion",
    copy: "Findings and evidence are stored encrypted, shared over an authenticated channel, and deleted on a documented schedule after the retest window closes.",
  },
  {
    icon: "FileText",
    title: "Sample report on request",
    copy: "Ask for a redacted sample report before you commit. You should never buy an assessment without seeing the shape of the deliverable.",
  },
  {
    icon: "Ban",
    title: "No reselling, no kickbacks",
    copy: "We are not a hardware or licence reseller and we take no vendor commission. Tooling recommendations are made on fit, not margin.",
  },
];

export const SCENARIOS = [
  {
    sector: "Fintech / NBFC",
    size: "180 employees · India",
    situation:
      "An RBI-regulated lending platform needed to satisfy a bank partner's vendor security review inside eight weeks, with no in-house security team and a monolithic core application.",
    work: [
      "Grey-box VAPT across the customer app, partner APIs and Active Directory",
      "Centralised logging with 180-day retention and CERT-In incident workflow",
      "Detection content for credential abuse, privilege escalation and data exfiltration",
    ],
    outcome:
      "Vendor questionnaire answered with evidence rather than promises: penetration test summary, monitoring evidence pack and an attestation letter, plus a prioritised remediation plan closed inside the window.",
  },
  {
    sector: "Healthcare / Life Sciences",
    size: "6 sites · multi-clinic group",
    situation:
      "A diagnostics chain held patient records across clinic servers and a cloud portal, with no visibility into who accessed what and an approaching DPDP readiness deadline.",
    work: [
      "Cloud posture assessment and hardening of the patient portal estate",
      "Personal-data access monitoring mapped to DPDP safeguards",
      "Endpoint monitoring across clinic workstations plus response playbooks",
    ],
    outcome:
      "Personal-data access became reportable and reviewable, public exposure of storage was eliminated, and the group gained a monthly evidence pack it can hand to an auditor or an enterprise customer.",
  },
  {
    sector: "B2B SaaS",
    size: "Series A · 90 employees",
    situation:
      "Enterprise deals were stalling on a SOC 2 Type II requirement while the engineering team shipped daily into a multi-tenant AWS estate with no landing zone.",
    work: [
      "Landing zone rebuild with policy-as-code guardrails and identity governance",
      "SIEM deployment with detections mapped to MITRE ATT&CK and 12-month retention",
      "Pre-audit readiness review against the SOC 2 trust services criteria",
    ],
    outcome:
      "Controls became continuous rather than assembled at audit time: infrastructure defined in code, evidence generated automatically, and security questionnaires answered from a single evidence pack.",
  },
  {
    sector: "Manufacturing",
    size: "3 plants · OT + IT",
    situation:
      "A manufacturer ran a flat network where plant control systems shared broadcast domains with office IT, and a ransomware incident at a peer had reached the board.",
    work: [
      "Segmentation design isolating OT cells from IT, validated by internal network testing",
      "Passive monitoring for the OT segment plus XDR across office endpoints",
      "Incident response playbooks and a tabletop exercise with plant leadership",
    ],
    outcome:
      "Lateral movement from an office compromise into production control systems was closed off, and the leadership team gained a rehearsed response plan with defined containment authority.",
  },
];

export const COMPLIANCE = [
  "SOC 2 Type II",
  "ISO 27001",
  "HIPAA",
  "PCI-DSS",
  "NIST 800-53",
  "CMMC",
  "DPDP Act (India)",
];
export const COMPLIANCE_CORE = COMPLIANCE.slice(0, 4);
export const COMPLIANCE_INDIA = ["DPDP Act 2023", "CERT-In Directions", "IT Act 2000", "RBI / SEBI / IRDAI", "ISO 27001"];

export const INDUSTRIES = [
  { name: "Healthcare", note: "HIPAA, health-data protection" },
  { name: "Financial Services & Fintech", note: "PCI-DSS, RBI/SEBI frameworks, SOC 2" },
  { name: "Government & Public Sector", note: "NIST 800-53, CMMC 2.0" },
  { name: "SaaS & Technology", note: "SOC 2, ISO 27001, vendor audits" },
  { name: "Manufacturing", note: "OT/ICS security, NIST CSF" },
  { name: "Education", note: "Student data protection, DPDP" },
];

const CTA_CONTACT = { label: "Get a Consultation", to: "/contact" };
const CTA_CAPS = { label: "View Capabilities", to: "#capabilities" };

export const BREADCRUMB_ROUTES = {
  Home: "/",
  Services: "/services",
  VAPT: "/services/vapt",
  "Managed Security": "/services/managed-security",
  "Managed Security Services": "/services/managed-security",
  Cybersecurity: "/services",
  "Cybersecurity Solutions": "/services/solutions",
  "Enterprise Landing Zone": "/services/enterprise-landing-zone",
  "Enterprise SIEM": "/services/enterprise-siem",
  "Enterprise XDR": "/services/enterprise-xdr",
  "Cloud Security": "/services/cloud-security",
  "Open Source SOC": "/services/open-source-soc",
  "Open Source SOC Model": "/services/open-source-soc",
  About: "/about",
  Industries: "/industries",
  Resources: "/resources",
  "Engagement Scenarios": "/case-studies",
  Contact: "/contact",
};

export const METHODOLOGY_GENERIC = [
  { title: "Assess", copy: "We audit your current security posture, map your compliance obligations and identify the gaps that matter." },
  { title: "Design", copy: "We architect controls mapped to the frameworks you're audited against, sized for your environment and budget." },
  { title: "Deploy", copy: "We implement and validate alongside your team, with every change documented and version-controlled." },
  { title: "Operate", copy: "Ongoing monitoring, tuning and support, either fully managed by Lanvaus or handed over to your engineers." },
];

const RISK_IBM_GLOBAL = { value: "₹22 crore", text: "Average cost of a data breach in India in 2025, the highest of any country (IBM Cost of a Data Breach Report 2025)." };
const RISK_IBM_DAYS = { value: "241 days", text: "Average time to identify and contain a breach in 2025 (IBM Cost of a Data Breach Report 2025)." };
const RISK_RANSOM = { value: "44%", text: "of breaches involved ransomware, up from 32% the year before (Verizon DBIR 2025)." };

export const SERVICES = {
  "/services": {
    breadcrumb: ["Home", "Services"],
    pill: "Our Services",
    titleLines: [
      [{ t: "Exclusively " }, { t: "Cybersecurity.", accent: true }],
      [{ t: "End to End." }],
    ],
    description:
      "Offense, defense, architecture and open source. Every Lanvaus engagement is delivered by security engineers and aligned to the frameworks your auditors actually check.",
    primaryCta: CTA_CONTACT,
    secondaryCta: { label: "Why Lanvaus", to: "/about" },
    image: IMAGES.serverRoom,
    isParent: true,
    children: [
      { title: "VAPT", to: "/services/vapt", copy: "Manual and tool-assisted vulnerability assessment and penetration testing across web, network, cloud and APIs." },
      { title: "Managed Security Services", to: "/services/managed-security", copy: "SOC as a Service run by our engineers 24/7, or SOC Deployment inside your own environment." },
      { title: "Cybersecurity Solutions", to: "/services/solutions", copy: "Enterprise Landing Zone, SIEM, XDR and Cloud Security designed, deployed and operated to your compliance requirements." },
      { title: "Open Source SOC Model", to: "/services/open-source-soc", copy: "An open-source SOC framework helping Indian SMBs meet DPDP, CERT-In and sector regulations affordably." },
    ],
  },

  "/services/solutions": {
    breadcrumb: ["Home", "Services", "Cybersecurity Solutions"],
    pill: "Enterprise Solutions",
    titleLines: [
      [{ t: "Security Architecture," }],
      [{ t: "Engineered ", accent: true }, { t: "End-to-End" }],
    ],
    description:
      "Deployable security infrastructure: landing zones, SIEM, XDR and cloud security, designed, implemented and hardened by Lanvaus engineers for regulated environments.",
    primaryCta: CTA_CONTACT,
    secondaryCta: { label: "See Managed SOC", to: "/services/managed-security" },
    image: IMAGES.serverRoom,
    isParent: true,
    children: [
      { title: "Enterprise Landing Zone", to: "/services/enterprise-landing-zone", copy: "A compliance-ready cloud foundation with guardrails, identity governance and segmentation built in." },
      { title: "Enterprise SIEM", to: "/services/enterprise-siem", copy: "SIEM design, onboarding, detection engineering and tuning aligned to retention requirements." },
      { title: "Enterprise XDR", to: "/services/enterprise-xdr", copy: "Unified detection and response across endpoints, identities, email and cloud workloads." },
      { title: "Cloud Security", to: "/services/cloud-security", copy: "Posture assessment, hardening and continuous compliance across Azure, AWS and GCP." },
    ],
  },

  "/services/vapt": {
    breadcrumb: ["Home", "Services", "VAPT"],
    pill: "Offensive Security",
    titleLines: [[{ t: "Penetration testing that finds " }], [{ t: "the gaps before attackers do.", accent: true }]],
    description:
      "Vulnerability Assessment and Penetration Testing across web applications, APIs, mobile, internal and external networks, cloud configurations and Active Directory. Manual and tool-assisted, delivered as black box, grey box or white box engagements, with retesting included after remediation.",
    primaryCta: CTA_CONTACT,
    secondaryCta: CTA_CAPS,
    image: IMAGES.codeScreens,
    showCerts: true,
    stats: [
      { value: "100%", label: "Of findings manually verified" },
      { value: "Up to 90%", label: "Fewer exploitable vulnerabilities post-remediation" },
      { value: "Zero", label: "Unverified scanner-only findings" },
      { value: "30 days", label: "Retest window included" },
    ],
    why: {
      eyebrow: "Why VAPT Matters",
      title: { pre: "Attackers only need ", accent: "one gap." },
      paragraphs: [
        "Automated scanners find the obvious. Real attackers chain the subtle: a verbose error message, an over-permissive API, a forgotten subdomain, a misconfigured identity provider. Penetration testing is the only way to see your environment the way an adversary does.",
        "Lanvaus engagements combine tooling with hands-on exploitation by experienced testers, scoped against your real attack surface and reported in language your engineers, auditors and leadership can each act on.",
      ],
      image: IMAGES.codeScreens,
    },
    risk: {
      eyebrow: "The Business Risk",
      title: { pre: "What happens when the ", accent: "gaps go untested?" },
      copy: "Unpatched vulnerabilities and misconfigurations are consistently among the most common ways attackers get in. Regulators and enterprise customers increasingly require independent testing before they will do business with you.",
      stats: [
        RISK_IBM_GLOBAL,
        { value: "34%", text: "Year-over-year increase in breaches that began with vulnerability exploitation (Verizon DBIR 2025)." },
        { value: "20%", text: "of breaches used vulnerability exploitation as the initial access vector (Verizon DBIR 2025)." },
        RISK_IBM_DAYS,
      ],
      highlights: [
        "Manual exploitation of every critical and high finding",
        "CVSS-scored findings with proof-of-concept evidence",
        "Black box, grey box and white box engagement options",
        "Remediation guidance your engineers can act on directly",
        "Retest of remediated findings included",
        "Findings mapped to SOC 2, ISO 27001, PCI-DSS and HIPAA controls",
        "Attestation letter suitable for auditors and customers",
      ],
    },
    audience: {
      title: { pre: "Built for teams that ", accent: "need proof, not assumptions." },
      copy: "VAPT is essential for any organization shipping software, handling regulated data or facing vendor security reviews, especially before audits, launches and enterprise deals.",
      cards: [
        { title: "CISO", note: "Independent validation of controls" },
        { title: "CTO", note: "Secure releases and architecture" },
        { title: "Head of Engineering", note: "Actionable, developer-ready findings" },
        { title: "Compliance Officer", note: "Evidence for SOC 2, ISO, PCI" },
        { title: "Product Owner", note: "Pre-launch security assurance" },
        { title: "IT Manager", note: "Network and AD hardening" },
      ],
    },
    capabilities: {
      title: { pre: "Everything an attacker ", accent: "would try." },
      cards: [
        { icon: "Globe", title: "Web Application Testing", copy: "OWASP Top 10 and beyond: authentication, session, access control, injection and business-logic flaws in your web applications." },
        { icon: "Braces", title: "API Security Testing", copy: "REST and GraphQL testing against the OWASP API Security Top 10: broken object-level authorization, excessive data exposure, rate limiting." },
        { icon: "Network", title: "Network Penetration Testing", copy: "External and internal network testing: exposed services, lateral movement paths, segmentation weaknesses and privilege escalation." },
        { icon: "Cloud", title: "Cloud Configuration Review", copy: "Azure, AWS and GCP configuration assessment: IAM, storage exposure, network controls, logging and key management." },
        { icon: "Smartphone", title: "Mobile App Testing", copy: "Android and iOS testing against OWASP MASVS: insecure storage, weak transport security, reverse engineering and API misuse." },
        { icon: "KeyRound", title: "Active Directory Assessment", copy: "Domain attack paths, Kerberos weaknesses, ACL abuse and privileged account exposure, mapped with BloodHound." },
      ],
    },
    methodology: {
      title: { pre: "A disciplined path from ", accent: "scope to signed-off remediation." },
      copy: "Every engagement follows PTES and NIST SP 800-115 aligned methodology, so results are repeatable, defensible and useful to auditors.",
      steps: [
        { title: "Assess", copy: "Define scope, rules of engagement and threat model; perform reconnaissance across the in-scope attack surface." },
        { title: "Design", copy: "Plan attack paths per asset class and select the manual and tool-assisted techniques that fit the engagement type." },
        { title: "Deploy", copy: "Execute testing, exploit and chain findings safely, and capture evidence-grade proof for every issue." },
        { title: "Operate", copy: "Deliver reports, walk your engineers through remediation and retest fixed findings within the included window." },
      ],
    },
    deliverables: [
      { icon: "FileText", title: "Executive Summary Report", copy: "Risk posture, key themes and business impact for leadership and the board." },
      { icon: "Bug", title: "Technical Findings Report", copy: "CVSS-scored findings with reproduction steps and proof of concept." },
      { icon: "Route", title: "Remediation Roadmap", copy: "Prioritized fixes with owners, effort estimates and quick wins." },
      { icon: "RefreshCw", title: "Retest Verification Report", copy: "Confirmation of which findings are closed after remediation." },
      { icon: "Scale", title: "Compliance Mapping", copy: "Which findings affect which SOC 2, ISO 27001, PCI-DSS or HIPAA controls." },
      { icon: "BadgeCheck", title: "Attestation Letter", copy: "Summary letter for auditors, customers and procurement teams." },
    ],
    stack: {
      title: { pre: "Tested with the tools ", accent: "attackers actually use." },
      copy: "We combine industry-standard commercial and open-source tooling with manual technique. Tools accelerate discovery; our engineers validate, chain and exploit.",
      badges: ["Burp Suite", "Nessus", "Nmap", "Metasploit", "OWASP ZAP", "BloodHound", "Nuclei"],
    },
    coverage: {
      eyebrow: "Testing Coverage",
      title: { pre: "What we test, and the ", accent: "standard we test it against." },
      copy: "Scanners are a starting point. Each asset class below is tested manually against a published methodology, and every critical or high finding is exploited and evidenced before it appears in your report.",
      columns: ["Asset class", "Techniques applied", "Methodology reference"],
      rows: [
        [
          "Web applications",
          "Authentication and session handling, IDOR and access-control bypass, injection (SQLi, SSTI, XXE), SSRF, file-upload abuse, business-logic and race conditions",
          "OWASP WSTG · OWASP Top 10",
        ],
        [
          "APIs (REST & GraphQL)",
          "Broken object and function-level authorization, mass assignment, excessive data exposure, rate-limit and quota abuse, GraphQL introspection and batching attacks",
          "OWASP API Security Top 10",
        ],
        [
          "External network",
          "Attack-surface discovery, subdomain and certificate enumeration, service fingerprinting, credential spraying against exposed portals, VPN and edge-device exploitation",
          "PTES · NIST SP 800-115",
        ],
        [
          "Internal network",
          "Relay and coercion attacks (NTLM/LLMNR), SMB and service misconfiguration, segmentation validation, privilege escalation, credential dumping paths",
          "PTES · MITRE ATT&CK",
        ],
        [
          "Active Directory",
          "Kerberoasting and AS-REP roasting, delegation abuse, ACL and ADCS misconfiguration, GPO abuse, attack-path analysis with BloodHound",
          "MITRE ATT&CK (TA0004 / TA0006)",
        ],
        [
          "Cloud (Azure / AWS / GCP)",
          "IAM and role-assumption paths, storage and snapshot exposure, key and secret sprawl, metadata service abuse, logging and guardrail gaps",
          "CIS Benchmarks · provider well-architected security pillar",
        ],
        [
          "Mobile (Android / iOS)",
          "Insecure local storage, weak transport security and pinning bypass, hardcoded secrets, reverse engineering and tamper resistance, backend API abuse",
          "OWASP MASVS / MASTG",
        ],
      ],
      footnote:
        "Engagements are executed against a written rules-of-engagement document. Denial-of-service and social engineering are excluded unless explicitly commissioned.",
    },
    timeline: {
      eyebrow: "Engagement Timeline",
      title: { pre: "A typical engagement, ", accent: "phase by phase." },
      copy: "Indicative durations for a mid-sized web application plus API engagement. Network, cloud and Active Directory scopes are sized separately, and the plan is agreed in writing before testing starts.",
      phases: [
        {
          title: "Scoping & rules of engagement",
          duration: "3-5 days before start",
          copy: "Asset inventory, engagement type per asset class, threat model, test accounts, testing window, source IPs, escalation contacts and exclusions, all signed off in writing.",
          outputs: "Signed SOW and rules-of-engagement document",
        },
        {
          title: "Reconnaissance & mapping",
          duration: "Day 1",
          copy: "Attack-surface discovery, application and API mapping, role and privilege matrix, technology fingerprinting, and identification of the highest-value attack paths.",
          outputs: "Coverage map and prioritised attack plan",
        },
        {
          title: "Vulnerability analysis",
          duration: "Days 1-2",
          copy: "Authenticated and unauthenticated tool-assisted analysis, followed by manual review of every candidate issue. Scanner output is treated as a lead, never as a finding.",
          outputs: "Verified candidate issue list",
        },
        {
          title: "Exploitation & chaining",
          duration: "Days 2-5",
          copy: "Manual exploitation of confirmed issues, privilege escalation, chaining of low-severity issues into demonstrable impact, and safe capture of proof-of-concept evidence.",
          outputs: "Evidence-grade proof per finding",
        },
        {
          title: "Post-exploitation & impact",
          duration: "Day 5",
          copy: "Demonstration of realistic business impact within agreed limits: what data is reachable, which accounts can be taken over, how far lateral movement extends.",
          outputs: "Impact narrative for leadership",
        },
        {
          title: "Reporting & walkthrough",
          duration: "3-5 days after testing",
          copy: "Executive summary, CVSS v3.1-scored technical findings with reproduction steps, remediation roadmap, compliance mapping, and a live walkthrough with your engineers.",
          outputs: "Full report pack plus attestation letter",
        },
        {
          title: "Remediation support & retest",
          duration: "Within 30 days",
          copy: "Direct access to the tester during remediation, then a retest of fixed findings and an updated verification report confirming what is closed.",
          outputs: "Retest verification report",
        },
      ],
    },
    severity: {
      eyebrow: "Severity Model",
      title: { pre: "How findings are ", accent: "rated and prioritised." },
      copy: "Every finding carries a CVSS v3.1 base score, then a business-context adjustment agreed with you, so remediation effort follows real risk rather than a raw number.",
      columns: ["Severity", "CVSS v3.1", "What it means", "Expected remediation"],
      rows: [
        ["Critical", "9.0 - 10.0", "Unauthenticated remote compromise, mass data exposure or full account takeover at scale", "Immediate: disclosed during testing, fix inside 7 days"],
        ["High", "7.0 - 8.9", "Authenticated privilege escalation, cross-tenant access or sensitive data exposure", "Fix inside 30 days"],
        ["Medium", "4.0 - 6.9", "Meaningful weakness requiring specific conditions or chaining to become impactful", "Fix inside 90 days"],
        ["Low", "0.1 - 3.9", "Limited impact, hardening and defence-in-depth improvements", "Next planned release cycle"],
        ["Informational", "n/a", "Observations, deviations from best practice and reconnaissance findings", "Backlog / risk-accept with rationale"],
      ],
      footnote:
        "Critical findings are disclosed to your escalation contact immediately on confirmation, not held back for the report.",
      tight: true,
    },
    resources: [
      { badge: "Free Whitepaper", icon: "BookOpen", title: "Scoping a Penetration Test: Black Box, Grey Box or White Box?", copy: "How to choose an engagement type, define scope and set rules of engagement that produce useful findings." },
      { badge: "Free Checklist", popular: true, icon: "ClipboardCheck", title: "Pre-Assessment Readiness Checklist", copy: "Everything to prepare before a VAPT engagement: asset inventory, test accounts, environments, approvals and points of contact." },
    ],
    closing: {
      title: { pre: "Ready to find the gaps ", accent: "before someone else does?" },
      copy: "Scope a penetration test with a Lanvaus engineer. We'll recommend the right engagement type for your environment and compliance goals.",
      secondary: { label: "Back to Services", to: "/services" },
    },
  },

  "/services/managed-security": {
    breadcrumb: ["Home", "Services", "Managed Security Services"],
    pill: "Managed Security Services",
    titleLines: [[{ t: "Managed SOC services." }], [{ t: "Your SOC, our engineers.", accent: true }]],
    description:
      "Two ways to run security operations: SOC as a Service, fully managed 24/7 by the Lanvaus team, or SOC Deployment, where we build a SOC stack inside your own environment and hand it over with training and optional ongoing support.",
    primaryCta: CTA_CONTACT,
    secondaryCta: CTA_CAPS,
    image: IMAGES.socCenter,
    showCerts: true,
    paths: [
      {
        title: "SOC as a Service",
        sub: "Fully Managed · Remote · 24/7",
        copy: "Fully managed 24/7 monitoring, threat detection, triage and incident response by the Lanvaus team, delivered remotely as a subscription.",
        points: [
          "24/7 monitoring, detection and response by Lanvaus engineers",
          "Detection engineering, tuning and threat hunting included",
          "Incident response with defined SLAs and containment authority",
          "Predictable monthly cost, no infrastructure or hiring burden",
        ],
        cta: { label: "Talk to Our SOC Team", to: "/contact" },
      },
      {
        title: "SOC Deployment",
        sub: "Deployed Inside Your Environment",
        copy: "We deploy and configure a SOC stack inside your own environment, either our enterprise build or our Open Source SOC Model, and hand it over with training and optional ongoing support.",
        points: [
          "Enterprise SOC build or Open Source SOC Model, your choice",
          "Deployed and configured inside your network or cloud",
          "Handover with training, runbooks and detection content",
          "Optional Lanvaus managed support after handover",
        ],
        cta: { label: "Plan a Deployment", to: "/contact" },
      },
    ],
    stats: [
      { value: "24/7", label: "Eyes-on-glass monitoring and response" },
      { value: "Up to 80%", label: "Faster threat detection with a managed SOC" },
      { value: "Up to 60%", label: "Lower cost than building an in-house SOC" },
      { value: "100%", label: "Detections mapped to MITRE ATT&CK" },
    ],
    why: {
      eyebrow: "Why Managed Security Matters",
      title: { pre: "Attacks don't keep ", accent: "business hours." },
      paragraphs: [
        "Most organizations have security tools. Far fewer have people watching them around the clock, tuning detections and responding within minutes. That gap between alert and action is where breaches become incidents.",
        "Lanvaus Managed Security Services put experienced engineers behind your telemetry, whether we run the SOC for you or deploy one you own. Either way, you get detection engineering, response playbooks and compliance reporting from day one.",
      ],
      image: IMAGES.socCenter,
    },
    risk: {
      eyebrow: "The Business Risk",
      title: { pre: "What happens when ", accent: "no one is watching?" },
      copy: "Long dwell times, unreviewed alerts and slow containment are the difference between a contained event and a reportable breach. Regulators now expect demonstrable monitoring, not just tooling.",
      stats: [
        RISK_IBM_DAYS,
        { value: "263 days", text: "Average time to identify and contain a breach in India in 2025 (IBM Cost of a Data Breach Report 2025)." },
        RISK_RANSOM,
        { value: "60%", text: "of breaches involved the human element such as phishing or credential misuse (Verizon DBIR 2025)." },
      ],
      highlights: [
        "24/7 monitoring, triage and incident response",
        "Detection rules tuned to your environment and threat model",
        "Defined SLAs for alert triage and containment",
        "Monthly posture reports and compliance evidence",
        "Log retention aligned to your regulatory requirements",
        "Choose fully managed or deployed in your environment",
        "Upgrade path from Open Source SOC to enterprise tooling",
      ],
    },
    audience: {
      title: { pre: "Built for organizations that ", accent: "can't staff a SOC alone." },
      copy: "Managed security fits any organization with regulatory monitoring obligations or real attack exposure that lacks the headcount to run 24/7 operations in-house.",
      cards: [
        { title: "CISO", note: "Coverage without 24/7 hiring" },
        { title: "CTO", note: "Security that scales with the platform" },
        { title: "IT Head", note: "Offload alert fatigue and tuning" },
        { title: "Compliance Officer", note: "Monitoring evidence for audits" },
        { title: "CEO of SMB", note: "Enterprise SOC at SMB cost" },
        { title: "Board / Risk Committee", note: "Measurable detection and response" },
      ],
    },
    capabilities: {
      title: { pre: "Everything a modern SOC ", accent: "should deliver." },
      cards: [
        { icon: "Radar", title: "24/7 Monitoring & Alerting", copy: "Continuous monitoring of endpoints, identities, cloud and network telemetry with human triage of every escalated alert." },
        { icon: "Crosshair", title: "Threat Detection & Hunting", copy: "MITRE ATT&CK-mapped detection engineering plus proactive hunts for threats that evade automated rules." },
        { icon: "Siren", title: "Incident Response", copy: "Defined playbooks, containment actions and communication plans, executed under agreed SLAs." },
        { icon: "Database", title: "Log Management & Retention", copy: "Centralized collection, normalization and retention aligned to CERT-In, PCI-DSS, HIPAA and ISO requirements." },
        { icon: "FileBarChart", title: "Compliance Reporting", copy: "Monthly posture reports and evidence packs that map monitoring activity to your framework controls." },
        { icon: "ShieldAlert", title: "Vulnerability Management", copy: "Continuous vulnerability scanning, prioritization and remediation tracking integrated with SOC workflows." },
      ],
    },
    methodology: {
      title: { pre: "From onboarding to ", accent: "steady-state operations." },
      copy: "Whether we run your SOC or deploy one for you, the same disciplined process gets you to reliable detection coverage quickly.",
      steps: [
        { title: "Assess", copy: "Inventory log sources, crown-jewel assets, existing tooling and the compliance obligations your SOC must evidence." },
        { title: "Design", copy: "Define the SOC architecture, detection use cases, escalation paths and SLAs for your engagement model." },
        { title: "Deploy", copy: "Onboard log sources, deploy detection content and playbooks, and validate coverage with purple-team exercises." },
        { title: "Operate", copy: "Monitor, triage, respond and tune continuously, with monthly reporting, or hand over to your team with training." },
      ],
    },
    deliverables: [
      { icon: "ListChecks", title: "Onboarding & Log Source Integration Plan", copy: "Prioritized log source inventory and integration schedule." },
      { icon: "Library", title: "Detection Rule Library", copy: "MITRE ATT&CK-mapped detection content tuned to your environment." },
      { icon: "FileBarChart", title: "Monthly Security Posture Report", copy: "Alerts, incidents, coverage and trends in one executive-ready report." },
      { icon: "BookOpenCheck", title: "Incident Response Playbooks", copy: "Step-by-step response procedures for your most likely incident types." },
      { icon: "FolderCheck", title: "Compliance Evidence Pack", copy: "Monitoring and response evidence mapped to your framework controls." },
      { icon: "FileSignature", title: "SLA Documentation", copy: "Agreed response times, escalation paths and service commitments." },
    ],
    stack: {
      title: { pre: "Built on platforms ", accent: "SOC teams trust." },
      copy: "We operate enterprise and open-source SOC platforms alike, so your SOC is built on tooling that fits your budget and compliance requirements, not a single vendor's roadmap.",
      badges: ["Microsoft Sentinel", "Wazuh", "Elastic", "Splunk", "TheHive", "MISP", "Velociraptor"],
    },
    slas: {
      eyebrow: "Service Levels",
      title: { pre: "The commitments we ", accent: "sign up to." },
      copy: "Target response times for a managed engagement. Final SLAs are contractual and agreed per client; these are the defaults we work to.",
      columns: ["Severity", "Triage target", "Client notification", "Containment action"],
      rows: [
        ["P1 — Active compromise", "15 minutes", "Phone call plus written notice", "Immediate, under pre-agreed containment authority"],
        ["P2 — Confirmed malicious activity", "30 minutes", "Written notice inside 1 hour", "Within 1 hour of confirmation"],
        ["P3 — Suspicious, needs investigation", "2 hours", "In the daily summary", "On confirmation"],
        ["P4 — Policy or hygiene issue", "Next business day", "In the monthly report", "Tracked to closure"],
      ],
      footnote:
        "Where CERT-In applies, the P1/P2 path is built to fit inside the mandated 6-hour incident reporting window, including approval and submission.",
    },
    spec: {
      eyebrow: "Operating Specification",
      title: { pre: "What the service ", accent: "actually consists of." },
      copy: "The operational detail security and engineering leaders ask for on the first call.",
      items: [
        { label: "Coverage", value: "24 x 7 x 365", note: "Follow-the-sun analyst rota with named escalation path and no answering service." },
        { label: "Detection framework", value: "MITRE ATT&CK mapped", note: "Coverage tracked per technique, with gap reporting each quarter." },
        { label: "Log retention", value: "Configurable, 180 days to 12 months+", note: "Set to your regulatory obligation: CERT-In 180 days, PCI-DSS 12 months." },
        { label: "Onboarding", value: "2-4 weeks to steady state", note: "Priority log sources live in week one; detection tuning continues through week four." },
        { label: "Response actions", value: "Isolate, disable, block, revoke", note: "Executed under written containment authority, with reversible actions first." },
        { label: "Reporting", value: "Monthly posture pack + on-demand", note: "Alert and incident volumes, SLA attainment, coverage and compliance evidence." },
      ],
    },
    resources: [
      { badge: "Free Whitepaper", icon: "BookOpen", title: "SOC as a Service vs. SOC Deployment: Choosing Your Model", copy: "A decision framework covering cost, control, compliance and staffing for both engagement models." },
      { badge: "Free Checklist", popular: true, icon: "ClipboardCheck", title: "SOC Readiness Checklist", copy: "Log sources, asset inventory, escalation contacts and retention requirements to prepare before onboarding." },
    ],
    closing: {
      title: { pre: "Ready to put engineers ", accent: "behind your alerts?" },
      copy: "Tell us about your environment and we'll recommend the engagement model that fits your team, budget and compliance obligations.",
      secondary: { label: "Back to Services", to: "/services" },
    },
  },

  "/services/enterprise-landing-zone": {
    breadcrumb: ["Home", "Services", "Cybersecurity Solutions", "Enterprise Landing Zone"],
    pill: "Enterprise Solution",
    titleLines: [[{ t: "Enterprise " }, { t: "Landing Zone", accent: true }]],
    description:
      "A pre-configured, compliance-ready cloud foundation with built-in security guardrails, identity governance and network segmentation, designed and deployed to Microsoft Cloud Adoption Framework and AWS Well-Architected principles.",
    primaryCta: CTA_CONTACT,
    secondaryCta: CTA_CAPS,
    image: IMAGES.serverRoom,
    stats: [
      { value: "Up to 70%", label: "Faster cloud migration" },
      { value: "100%", label: "Policy-as-code compliance coverage" },
      { value: "Zero", label: "Misconfigurations at deploy" },
      { value: "3x", label: "Faster workload onboarding" },
    ],
    why: {
      eyebrow: "Why Landing Zones Matter",
      title: { pre: "Your cloud foundation ", accent: "determines everything above it." },
      paragraphs: [
        "Most cloud security failures originate in the foundation: misconfigured subscriptions, flat network topologies and over-privileged identities. A landing zone eliminates these risks before your first workload deploys.",
        "Lanvaus designs and deploys landing zones aligned to Microsoft's Cloud Adoption Framework and AWS Well-Architected principles, customized to your compliance requirements, organizational structure and growth plans.",
      ],
      image: IMAGES.skyline,
    },
    risk: {
      eyebrow: "The Business Risk",
      title: { pre: "What happens without ", accent: "a secure foundation?" },
      copy: "Organizations that skip the landing zone phase pay for it later in breaches, failed audits, rework and delayed transformation. Retrofitting guardrails onto a live estate is slower and riskier than building them in.",
      stats: [
        RISK_IBM_GLOBAL,
        { value: "82%", text: "of breaches involved data stored in cloud environments (IBM Cost of a Data Breach Report)." },
        { value: "99%", text: "of cloud security failures through 2025 are predicted to be the customer's fault, mostly misconfiguration (Gartner)." },
      ],
      highlights: [
        "Eliminate misconfigurations before workloads deploy",
        "Pass compliance audits from day one: HIPAA, SOC 2, PCI-DSS",
        "Consistent, repeatable infrastructure-as-code deployments",
        "Onboard new workloads faster with pre-built guardrails",
        "Finance visibility into cloud cost allocation",
        "Network micro-segmentation that prevents lateral movement",
        "Identity governance with least-privilege enforcement",
      ],
    },
    audience: {
      title: { pre: "Built for organizations that ", accent: "can't afford to get the cloud wrong." },
      copy: "Landing zones are essential for any enterprise moving to or expanding within the cloud, particularly those with regulatory obligations, multi-team environments or hybrid infrastructure.",
      cards: [
        { title: "CTO", note: "Scaling cloud adoption safely" },
        { title: "CISO", note: "Guardrails enforced by design" },
        { title: "Cloud Architect", note: "CAF / Well-Architected alignment" },
        { title: "Regulated Industries", note: "Healthcare, finance, government" },
        { title: "Multi-Cloud Orgs", note: "Azure, AWS, GCP environments" },
        { title: "Growth-Stage Companies", note: "Scaling infrastructure fast" },
      ],
    },
    capabilities: {
      title: { pre: "Everything your cloud ", accent: "needs to be secure." },
      cards: [
        { icon: "Cloud", title: "Multi-Cloud Architecture", copy: "Pre-configured Azure and AWS landing zones with built-in guardrails, network topology and resource organization aligned to CAF." },
        { icon: "Lock", title: "Identity & Access Governance", copy: "Centralized identity with Entra ID, conditional access, privileged identity management and role-based access control." },
        { icon: "Server", title: "Network Segmentation", copy: "Hub-and-spoke topology with Azure Firewall, NSGs, private endpoints and micro-segmentation to isolate workloads." },
        { icon: "Settings", title: "Policy-as-Code", copy: "Azure Policy and AWS Service Control Policies enforced at scale: guardrails that prevent misconfigurations before they happen." },
        { icon: "BarChart3", title: "Cost Management & Tagging", copy: "Tagging taxonomies, budget alerts and cost allocation that give finance visibility and engineering accountability." },
        { icon: "GitBranch", title: "Infrastructure as Code", copy: "Terraform and Bicep templates for repeatable, version-controlled deployments: consistent, auditable and recoverable." },
      ],
    },
    methodology: {
      title: { pre: "From blank tenant to ", accent: "production-ready foundation." },
      copy: "A proven, framework-aligned methodology that delivers a landing zone your teams can build on immediately.",
      steps: [
        { title: "Assess", copy: "Review existing cloud footprint, compliance obligations, identity model and organizational structure." },
        { title: "Design", copy: "Architect the management-group hierarchy, network topology, identity governance and policy baseline." },
        { title: "Deploy", copy: "Provision the landing zone with Terraform or Bicep through CI/CD pipelines, validated against the policy baseline." },
        { title: "Operate", copy: "Hand over runbooks and IaC, or let Lanvaus operate the platform with drift detection and continuous compliance." },
      ],
    },
    deliverables: [
      { icon: "FileText", title: "Landing Zone Architecture Document", copy: "Target-state design covering hierarchy, networking, identity and governance." },
      { icon: "GitBranch", title: "Infrastructure-as-Code Repository", copy: "Terraform / Bicep code with pipelines for repeatable deployment." },
      { icon: "Settings", title: "Policy-as-Code Baseline", copy: "Enforced guardrails mapped to your compliance frameworks." },
      { icon: "Network", title: "Network Topology Diagrams", copy: "Hub-and-spoke and segmentation diagrams for your estate." },
      { icon: "Lock", title: "Identity & Access Design", copy: "RBAC model, PIM configuration and conditional access policies." },
      { icon: "BookOpenCheck", title: "Operations Runbook", copy: "Day-two procedures for onboarding, changes and incident handling." },
    ],
    stack: {
      title: { pre: "Built on platforms ", accent: "you already trust." },
      copy: "Our landing zones leverage native cloud services and industry-standard IaC tools, ensuring maximum compatibility, support and long-term maintainability.",
      badges: ["Microsoft Azure", "AWS", "Terraform", "Bicep / ARM", "Entra ID", "Azure Firewall", "GitHub Actions", "Azure DevOps"],
    },
    spec: {
      eyebrow: "Reference Architecture",
      title: { pre: "The decisions a landing zone ", accent: "locks in for you." },
      copy: "What actually ships. Every item below is delivered as reviewable infrastructure code, not a slide deck.",
      items: [
        { label: "Scope hierarchy", value: "Platform / workload / sandbox separation", note: "Management groups or organisational units with policy inherited by design." },
        { label: "Environment isolation", value: "Subscription or account per environment", note: "Production, non-production and sandbox never share a security boundary." },
        { label: "Network topology", value: "Hub-and-spoke with inspected egress", note: "Shared firewall, IDPS, private DNS and hybrid connectivity in the hub." },
        { label: "Service exposure", value: "Private endpoints, public access disabled", note: "Platform data services unreachable from the internet by policy." },
        { label: "Identity model", value: "RBAC as code + just-in-time elevation", note: "Group-based assignment, no standing admin, monitored break-glass accounts." },
        { label: "Guardrails", value: "Deny + audit policy baseline", note: "Blocks unencrypted storage, public data services, untagged resources and unapproved regions." },
        { label: "Delivery", value: "Terraform or Bicep via CI/CD", note: "Remote state with locking, plan review on pull request, drift detection on a schedule." },
        { label: "Observability", value: "Diagnostics enabled by policy", note: "Every new resource logs from creation into your central workspace." },
        { label: "Cost governance", value: "Tag taxonomy + budget alerts", note: "Owner, environment and data-classification tags enforced at deploy time." },
      ],
    },
    resources: [
      { badge: "Free Whitepaper", icon: "BookOpen", title: "Enterprise Landing Zone Architecture Blueprint", copy: "Reference architecture covering subscription hierarchy, network topology, identity federation and policy frameworks." },
      { badge: "Free Checklist", popular: true, icon: "ClipboardCheck", title: "Compliance Readiness Checklist: HIPAA, SOC 2, PCI-DSS & ISO 27001", copy: "Pre-audit readiness checklist with control mappings, evidence requirements and common gap areas." },
    ],
    closing: {
      title: { pre: "Ready to build your ", accent: "secure cloud foundation?" },
      copy: "Get a complimentary architecture review and landing zone assessment tailored to your organization's cloud strategy.",
      secondary: { label: "Back to Services", to: "/services" },
    },
  },

  "/services/enterprise-siem": {
    breadcrumb: ["Home", "Services", "Cybersecurity Solutions", "Enterprise SIEM"],
    pill: "Enterprise Solution",
    titleLines: [[{ t: "Enterprise SIEM that " }], [{ t: "sees everything, misses nothing.", accent: true }]],
    description:
      "SIEM design, deployment, log source onboarding, detection engineering and tuning, aligned to the retention and reporting requirements of the frameworks you're audited against.",
    primaryCta: CTA_CONTACT,
    secondaryCta: CTA_CAPS,
    image: IMAGES.dashboard,
    stats: [
      { value: "100%", label: "Critical log source coverage" },
      { value: "Up to 80%", label: "Fewer false positives after tuning" },
      { value: "Up to 90%", label: "Faster investigations with correlated alerts" },
      { value: "365 days", label: "Retention aligned to compliance needs" },
    ],
    why: {
      eyebrow: "Why SIEM Matters",
      title: { pre: "You can't defend ", accent: "what you can't see." },
      paragraphs: [
        "Security telemetry lives in dozens of places: identity providers, firewalls, endpoints, cloud control planes, SaaS applications. Without a central platform correlating it, attacks that span systems go unnoticed until damage is done.",
        "Lanvaus designs and deploys SIEM platforms that ingest the right sources, apply detection content mapped to MITRE ATT&CK and retain data to meet your regulatory obligations, without drowning your team in noise or storage costs.",
      ],
      image: IMAGES.dashboard,
    },
    risk: {
      eyebrow: "The Business Risk",
      title: { pre: "What happens without ", accent: "centralized visibility?" },
      copy: "Untuned or absent SIEM leads to missed detections, months-long dwell times and failed audits when regulators ask for log evidence you can't produce.",
      stats: [
        RISK_IBM_DAYS,
        RISK_IBM_GLOBAL,
        RISK_RANSOM,
      ],
      highlights: [
        "Right-sized architecture that controls ingestion cost",
        "Prioritized onboarding of your highest-value log sources",
        "Detection rules mapped to MITRE ATT&CK techniques",
        "Retention policies matched to PCI-DSS, HIPAA, CERT-In and ISO",
        "Compliance dashboards that double as audit evidence",
        "Continuous tuning to keep false positives low",
        "Ready for Lanvaus managed SOC operations",
      ],
    },
    audience: {
      title: { pre: "Built for teams that need ", accent: "signal, not noise." },
      copy: "Enterprise SIEM fits organizations with regulatory logging obligations, distributed hybrid estates, or existing SIEM deployments that generate alerts nobody trusts.",
      cards: [
        { title: "CISO", note: "Visibility across the whole estate" },
        { title: "SOC Manager", note: "Fewer, better alerts" },
        { title: "IT Head", note: "Centralized log management" },
        { title: "Compliance Officer", note: "Retention and reporting evidence" },
        { title: "Cloud Architect", note: "Cloud-native telemetry pipelines" },
        { title: "CTO", note: "Platform-wide security posture" },
      ],
    },
    capabilities: {
      title: { pre: "Everything your SIEM ", accent: "needs to deliver." },
      cards: [
        { icon: "Server", title: "SIEM Architecture & Sizing", copy: "Platform selection, ingestion sizing and tiered storage design that balance coverage with cost." },
        { icon: "Database", title: "Log Source Onboarding", copy: "Prioritized onboarding of identity, endpoint, network, cloud and application sources with parsing and normalization." },
        { icon: "Crosshair", title: "Detection Engineering", copy: "Analytics rules mapped to MITRE ATT&CK, tuned to your environment and validated against real attack techniques." },
        { icon: "Lightbulb", title: "Use Case Development", copy: "Business-specific detection use cases for your applications, privileged access paths and regulated data flows." },
        { icon: "FileBarChart", title: "Compliance Retention & Reporting", copy: "Retention policies and dashboards aligned to PCI-DSS, HIPAA, ISO 27001, CERT-In and SOC 2." },
        { icon: "SlidersHorizontal", title: "SIEM Tuning & Optimization", copy: "Ongoing rule tuning, ingestion optimization and health monitoring to keep the platform sharp." },
      ],
    },
    methodology: {
      title: { pre: "From log chaos to ", accent: "high-fidelity detection." },
      copy: "A structured approach that gets your SIEM producing trustworthy alerts and audit-ready evidence.",
      steps: [
        { title: "Assess", copy: "Inventory log sources, estimate volumes, review existing detections and map retention obligations." },
        { title: "Design", copy: "Architect the platform, storage tiers, data model and detection use-case roadmap." },
        { title: "Deploy", copy: "Onboard sources, deploy the detection rule pack and dashboards, validate with attack simulation." },
        { title: "Operate", copy: "Tune continuously, expand coverage and transfer knowledge, or run it as part of Lanvaus managed SOC." },
      ],
    },
    deliverables: [
      { icon: "FileText", title: "SIEM Architecture Document", copy: "Platform design, sizing, data flows and storage tiering." },
      { icon: "ListChecks", title: "Log Source Inventory & Onboarding Matrix", copy: "Every source, its priority, parser and onboarding status." },
      { icon: "Library", title: "Detection Rule Pack", copy: "Analytics rules mapped to MITRE ATT&CK techniques." },
      { icon: "LayoutDashboard", title: "Compliance Dashboards", copy: "Framework-aligned dashboards ready for audit review." },
      { icon: "BookOpenCheck", title: "Alert Triage Runbooks", copy: "Step-by-step triage guidance for every detection category." },
      { icon: "GraduationCap", title: "Knowledge Transfer Sessions", copy: "Hands-on training so your team owns the platform." },
    ],
    stack: {
      title: { pre: "Built on platforms ", accent: "your analysts already know." },
      copy: "We design and deploy on leading commercial and open-source SIEM platforms, choosing the one that fits your budget, cloud footprint and team skills.",
      badges: ["Microsoft Sentinel", "Splunk", "Elastic", "Wazuh", "Azure Monitor", "Logstash"],
    },
    spec: {
      eyebrow: "Technical Specification",
      title: { pre: "Design decisions we ", accent: "make explicit." },
      copy: "The engineering detail that determines whether a SIEM produces trustworthy alerts or an unaffordable archive.",
      items: [
        { label: "Sizing basis", value: "Events per second + GB/day per source", note: "Modelled per source class before onboarding, with growth headroom and ingestion caps." },
        { label: "Storage tiering", value: "Hot / warm / archive", note: "Detection in hot, investigation in warm, compliance-only volume in low-cost archive with a tested rehydration path." },
        { label: "Data model", value: "Normalised schema (ASIM / ECS)", note: "Parsers and field mapping validated before detection rules are written." },
        { label: "Detection content", value: "ATT&CK-mapped analytic rules", note: "Every rule carries a technique mapping, a triage runbook and a named owner." },
        { label: "Validation", value: "Attack simulation per use case", note: "Detections proven with simulated technique execution, not assumed from vendor docs." },
        { label: "Pipeline health", value: "Silent-source alerting", note: "Ingestion monitored so a stopped source is caught in hours, not at audit time." },
      ],
    },
    resources: [
      { badge: "Free Whitepaper", icon: "BookOpen", title: "SIEM Sizing and Log Source Prioritization Guide", copy: "How to decide what to ingest first, estimate volumes and control cost without losing coverage." },
      { badge: "Free Checklist", popular: true, icon: "ClipboardCheck", title: "Compliance Log Retention Checklist", copy: "Retention and logging requirements across PCI-DSS, HIPAA, ISO 27001, CERT-In and SOC 2 in one reference." },
    ],
    closing: {
      title: { pre: "Ready to see ", accent: "everything?" },
      copy: "Get a SIEM architecture review covering coverage gaps, ingestion cost and detection quality.",
      secondary: { label: "Back to Services", to: "/services" },
    },
  },

  "/services/enterprise-xdr": {
    breadcrumb: ["Home", "Services", "Cybersecurity Solutions", "Enterprise XDR"],
    pill: "Enterprise Solution",
    titleLines: [[{ t: "Enterprise XDR: unified detection" }], [{ t: "across endpoint, identity and cloud.", accent: true }]],
    description:
      "XDR platform selection, deployment, policy configuration and integration with your SIEM and SOC workflows, so detection and response work as one system across endpoints, identities, email and cloud workloads.",
    primaryCta: CTA_CONTACT,
    secondaryCta: CTA_CAPS,
    image: IMAGES.padlock,
    stats: [
      { value: "100%", label: "Endpoint, identity and cloud coverage" },
      { value: "Up to 90%", label: "Faster containment with automated response" },
      { value: "Zero", label: "Blind spots between security tools" },
      { value: "24/7", label: "Automated response, even off-hours" },
    ],
    why: {
      eyebrow: "Why XDR Matters",
      title: { pre: "Attacks cross boundaries. ", accent: "Your defenses should too." },
      paragraphs: [
        "A phishing email becomes a stolen credential, which becomes a compromised endpoint, which becomes lateral movement into cloud workloads. Point tools each see one step. XDR correlates the whole story and responds automatically.",
        "Lanvaus selects, deploys and configures XDR platforms, integrates them with your SIEM and SOC workflows, and builds automated response playbooks so containment happens in minutes rather than shift changes.",
      ],
      image: IMAGES.padlock,
    },
    risk: {
      eyebrow: "The Business Risk",
      title: { pre: "What happens when tools ", accent: "don't talk to each other?" },
      copy: "Siloed endpoint, identity and email security leaves gaps attackers move through freely, and slows response while analysts pivot between consoles.",
      stats: [
        { value: "22%", text: "of breaches used credential abuse as the initial access vector (Verizon DBIR 2025)." },
        RISK_RANSOM,
        { value: "70%", text: "of successful breaches originate at the endpoint (IDC)." },
        RISK_IBM_DAYS,
      ],
      highlights: [
        "Single investigation plane across endpoint, identity, email and cloud",
        "Automated isolation, account disable and IOC blocking playbooks",
        "Coverage assessment showing exactly what is and isn't protected",
        "Integration with Microsoft Sentinel or your existing SIEM",
        "Threat intelligence enrichment on every alert",
        "Phased rollout methodology with zero business disruption",
        "Operations handover or Lanvaus co-managed model",
      ],
    },
    audience: {
      title: { pre: "Built for teams that ", accent: "need to respond in minutes." },
      copy: "XDR fits organizations with distributed endpoints, hybrid identity and cloud workloads, where attackers move faster than manual investigation allows.",
      cards: [
        { title: "CISO", note: "Unified detection and response" },
        { title: "IT Head", note: "One console, fewer tools" },
        { title: "Endpoint / Infrastructure Lead", note: "Hardened, monitored fleets" },
        { title: "SOC Manager", note: "Automated triage and containment" },
        { title: "CTO", note: "Security across the whole platform" },
        { title: "Compliance Officer", note: "Endpoint protection evidence" },
      ],
    },
    capabilities: {
      title: { pre: "Everything XDR ", accent: "should cover." },
      cards: [
        { icon: "Laptop", title: "Endpoint Detection & Response", copy: "Behavioral detection, device isolation and forensic collection across Windows, macOS, Linux and mobile." },
        { icon: "Fingerprint", title: "Identity Threat Protection", copy: "Detection of credential theft, impossible travel, privilege escalation and identity-based lateral movement." },
        { icon: "Mail", title: "Email & Collaboration Security", copy: "Phishing, business email compromise and malicious attachment protection across email and collaboration tools." },
        { icon: "Cloud", title: "Cloud Workload Protection", copy: "Runtime protection for VMs, containers and serverless with posture signals correlated into incidents." },
        { icon: "Zap", title: "Automated Response Playbooks", copy: "Isolate hosts, disable accounts, block indicators and open tickets automatically with human approval where needed." },
        { icon: "Rss", title: "Threat Intelligence Integration", copy: "Enrich alerts with curated threat intelligence to prioritize what matters and cut investigation time." },
      ],
    },
    methodology: {
      title: { pre: "From fragmented tools to ", accent: "unified response." },
      copy: "A phased methodology that delivers full coverage without disrupting users or operations.",
      steps: [
        { title: "Assess", copy: "Map your endpoint, identity, email and cloud estate, existing tooling and current detection coverage gaps." },
        { title: "Design", copy: "Select the XDR platform, define policies, response playbooks and SIEM integration architecture." },
        { title: "Deploy", copy: "Roll out agents and policies in phases, integrate with SIEM and validate detection with attack simulation." },
        { title: "Operate", copy: "Tune policies, expand automation and hand over to your team, or co-manage with Lanvaus SOC." },
      ],
    },
    deliverables: [
      { icon: "FileText", title: "XDR Deployment Plan", copy: "Phased rollout schedule, prerequisites and success criteria." },
      { icon: "Settings", title: "Policy & Configuration Baseline", copy: "Hardened detection and prevention policies per device class." },
      { icon: "FileBarChart", title: "Coverage Assessment Report", copy: "What is protected, what isn't and how gaps are closed." },
      { icon: "Zap", title: "Automated Response Playbooks", copy: "Documented automation for your highest-priority incident types." },
      { icon: "GitBranch", title: "SIEM Integration Documentation", copy: "Connectors, data flows and correlation configuration." },
      { icon: "BookOpenCheck", title: "Operations Handover Guide", copy: "Day-two procedures for tuning, exclusions and incident handling." },
    ],
    stack: {
      title: { pre: "Built on platforms ", accent: "leading the market." },
      copy: "We work with the leading XDR platforms and integrate them into Microsoft Sentinel or your existing SIEM, so you get unified visibility without a forklift replacement.",
      badges: ["Microsoft Defender XDR", "CrowdStrike", "SentinelOne", "Microsoft Sentinel", "Defender for Cloud"],
    },
    coverage: {
      eyebrow: "Coverage Matrix",
      title: { pre: "What gets covered, ", accent: "domain by domain." },
      copy: "XDR is only as good as its coverage. We baseline every domain before rollout and report the percentage reporting healthy telemetry, so gaps are known rather than assumed away.",
      columns: ["Domain", "Signals collected", "Automated response available"],
      rows: [
        ["Endpoint", "Process trees, registry and file activity, script-block logging, network connections, memory indicators", "Isolate device, kill process, quarantine file, collect forensic package"],
        ["Identity", "Sign-in anomalies, token and session abuse, MFA fatigue, privilege escalation, directory changes", "Disable account, revoke sessions and refresh tokens, force re-authentication"],
        ["Email & collaboration", "Phishing and BEC indicators, malicious attachments and links, mailbox rule changes, delegation abuse", "Purge message tenant-wide, block sender, disable forwarding rule"],
        ["Cloud workloads", "Runtime behaviour on VMs, containers and serverless, plus posture signals correlated into incidents", "Quarantine workload, revoke credential, block indicator at the edge"],
        ["SaaS applications", "OAuth consent grants, admin role changes, anomalous data export", "Revoke app consent, disable integration, alert with enrichment"],
      ],
      footnote:
        "Unmanaged devices, legacy operating systems and OT assets are handled separately — we tell you what XDR cannot cover instead of leaving it unstated.",
      tight: true,
    },
    resources: [
      { badge: "Free Whitepaper", icon: "BookOpen", title: "EDR vs. XDR: What Changes and Why It Matters", copy: "How extended detection and response changes coverage, investigation speed and staffing requirements." },
      { badge: "Free Checklist", popular: true, icon: "ClipboardCheck", title: "XDR Rollout Readiness Checklist", copy: "Device inventory, identity prerequisites, exclusions and change-management steps for a smooth rollout." },
    ],
    closing: {
      title: { pre: "Ready to unify ", accent: "detection and response?" },
      copy: "Get a coverage assessment showing where your current tools leave gaps and how XDR closes them.",
      secondary: { label: "Back to Services", to: "/services" },
    },
  },

  "/services/cloud-security": {
    breadcrumb: ["Home", "Services", "Cybersecurity Solutions", "Cloud Security"],
    pill: "Enterprise Solution",
    titleLines: [[{ t: "Cloud security " }, { t: "at every layer.", accent: true }]],
    description:
      "Cloud security posture assessment, hardening, identity governance, workload protection and continuous compliance monitoring across Azure, AWS and GCP.",
    primaryCta: CTA_CONTACT,
    secondaryCta: CTA_CAPS,
    image: IMAGES.matrix,
    stats: [
      { value: "100%", label: "Continuous posture visibility" },
      { value: "Up to 85%", label: "Reduction in critical misconfigurations" },
      { value: "Zero", label: "Publicly exposed sensitive data stores" },
      { value: "24/7", label: "Continuous compliance monitoring" },
    ],
    why: {
      eyebrow: "Why Cloud Security Matters",
      title: { pre: "The cloud is secure. ", accent: "Your configuration might not be." },
      paragraphs: [
        "Cloud providers secure the infrastructure. Everything above it, identities, storage permissions, network rules, workloads and keys, is your responsibility, and it changes every time an engineer ships.",
        "Lanvaus assesses and hardens your cloud estate, puts identity governance and workload protection in place, and deploys continuous compliance monitoring so posture stays strong as your environment evolves.",
      ],
      image: IMAGES.matrix,
    },
    risk: {
      eyebrow: "The Business Risk",
      title: { pre: "What happens when ", accent: "configuration drifts?" },
      copy: "Misconfigured storage, over-privileged identities and unmonitored workloads are among the most common causes of cloud breaches, and the easiest for attackers to find.",
      stats: [
        { value: "82%", text: "of breaches involved data stored in cloud environments (IBM Cost of a Data Breach Report)." },
        { value: "99%", text: "of cloud security failures through 2025 are predicted to be the customer's fault, mostly misconfiguration (Gartner)." },
        RISK_IBM_GLOBAL,
        { value: "30%", text: "of breaches involved a third party, including cloud and SaaS providers (Verizon DBIR 2025)." },
      ],
      highlights: [
        "Full posture assessment across Azure, AWS and GCP",
        "Prioritized hardening plan with remediation tracking",
        "Least-privilege identity governance and entitlement cleanup",
        "Workload and container protection at runtime",
        "Encryption and key management aligned to your frameworks",
        "Continuous compliance monitoring with drift alerts",
        "Findings mapped to CIS, ISO 27001, SOC 2 and PCI-DSS",
      ],
    },
    audience: {
      title: { pre: "Built for teams that ", accent: "ship fast in regulated industries." },
      copy: "Cloud security fits any organization running production workloads in public cloud, especially those with compliance obligations, multi-account estates or fast-moving DevOps teams.",
      cards: [
        { title: "CTO", note: "Security that keeps pace with delivery" },
        { title: "Cloud Architect", note: "Hardened, well-architected estates" },
        { title: "CISO", note: "Continuous visibility and control" },
        { title: "DevOps Lead", note: "Guardrails in CI/CD, not blockers" },
        { title: "Compliance Officer", note: "Cloud controls mapped to frameworks" },
        { title: "CEO of Growth-Stage Company", note: "Enterprise-ready security posture" },
      ],
    },
    capabilities: {
      title: { pre: "Everything your cloud ", accent: "needs at every layer." },
      cards: [
        { icon: "ScanSearch", title: "Cloud Security Posture Management", copy: "Continuous misconfiguration detection benchmarked against CIS, NIST and your compliance frameworks." },
        { icon: "Lock", title: "Identity & Access Hardening", copy: "Least-privilege enforcement, entitlement cleanup, MFA and conditional access across cloud identities." },
        { icon: "Container", title: "Workload & Container Protection", copy: "Runtime protection and vulnerability management for VMs, Kubernetes and serverless workloads." },
        { icon: "KeyRound", title: "Data Protection & Encryption", copy: "Storage exposure remediation, encryption at rest and in transit, and key management architecture." },
        { icon: "Network", title: "Network Security & Segmentation", copy: "Security groups, private endpoints, firewall policy and segmentation that limit lateral movement." },
        { icon: "Activity", title: "Continuous Compliance Monitoring", copy: "Always-on compliance scoring with drift alerts and audit-ready evidence exports." },
      ],
    },
    methodology: {
      title: { pre: "From assessment to ", accent: "continuous assurance." },
      copy: "A structured methodology that hardens your estate today and keeps it hardened as it changes.",
      steps: [
        { title: "Assess", copy: "Run a full posture assessment across accounts and subscriptions, benchmarked against CIS and your frameworks." },
        { title: "Design", copy: "Build the hardening baseline, identity governance model and monitoring architecture for your estate." },
        { title: "Deploy", copy: "Remediate findings, deploy CSPM and workload protection, and embed guardrails into CI/CD." },
        { title: "Operate", copy: "Monitor continuously, respond to drift and report compliance posture, in-house or via Lanvaus." },
      ],
    },
    deliverables: [
      { icon: "FileText", title: "Cloud Security Assessment Report", copy: "Findings, risk ratings and benchmark scores across your cloud estate." },
      { icon: "Route", title: "Hardening Baseline & Remediation Plan", copy: "Prioritized fixes with owners and target configurations." },
      { icon: "Lock", title: "Identity Governance Design", copy: "Least-privilege model, role design and access review process." },
      { icon: "ScanSearch", title: "CSPM Configuration", copy: "Deployed posture management tuned to your frameworks." },
      { icon: "Scale", title: "Compliance Mapping Matrix", copy: "Cloud controls mapped to CIS, ISO 27001, SOC 2 and PCI-DSS." },
      { icon: "BookOpenCheck", title: "Cloud Security Runbook", copy: "Operating procedures for drift, incidents and access changes." },
    ],
    stack: {
      title: { pre: "Built on platforms ", accent: "native to your cloud." },
      copy: "We use cloud-native security services first and add best-in-class tooling where it closes real gaps, keeping cost and complexity under control.",
      badges: ["Microsoft Defender for Cloud", "AWS Security Hub", "Azure Policy", "Prisma Cloud", "Terraform", "Entra ID"],
    },
    coverage: {
      eyebrow: "Control Mapping",
      title: { pre: "Cloud controls mapped to ", accent: "the frameworks you're audited against." },
      copy: "Findings are not delivered as a raw benchmark dump. Each control area is mapped to the specific framework clauses your auditors will test, with the evidence artifact named.",
      columns: ["Control area", "Benchmark reference", "Framework mapping", "Evidence produced"],
      rows: [
        ["Identity & access", "CIS 1.x", "ISO 27001 A.5.15-A.5.18 · SOC 2 CC6.1 · PCI-DSS 7-8", "Role model, entitlement review export, MFA enforcement report"],
        ["Logging & monitoring", "CIS 3.x", "ISO 27001 A.8.15-A.8.16 · SOC 2 CC7.2 · PCI-DSS 10", "Diagnostic settings inventory, retention configuration export"],
        ["Network security", "CIS 4.x-5.x", "ISO 27001 A.8.20-A.8.22 · PCI-DSS 1", "Segmentation diagram, NSG/security-group review, exposure report"],
        ["Data protection", "CIS 2.x", "ISO 27001 A.8.24 · SOC 2 CC6.7 · HIPAA 164.312(a)(2)(iv)", "Encryption and key management configuration, public-exposure remediation log"],
        ["Workload security", "CIS 6.x", "ISO 27001 A.8.8 · SOC 2 CC7.1", "Vulnerability posture report, image scan results, remediation SLA tracking"],
        ["Governance & drift", "CIS 1.x", "ISO 27001 A.5.36 · SOC 2 CC3.2", "Policy-as-code baseline, compliance score trend, drift alert history"],
      ],
      tight: true,
    },
    resources: [
      { badge: "Free Whitepaper", icon: "BookOpen", title: "Cloud Shared Responsibility: What Your Provider Doesn't Secure", copy: "A practical guide to the controls that remain your responsibility across Azure, AWS and GCP." },
      { badge: "Free Checklist", popular: true, icon: "ClipboardCheck", title: "Cloud Security Hardening Checklist", copy: "Identity, storage, network, logging and key management checks for your first posture review." },
    ],
    closing: {
      title: { pre: "Ready to secure ", accent: "every layer?" },
      copy: "Get a cloud posture assessment and a prioritized hardening plan for your Azure, AWS or GCP estate.",
      secondary: { label: "Back to Services", to: "/services" },
    },
  },

  "/services/open-source-soc": {
    breadcrumb: ["Home", "Services", "Open Source SOC Model"],
    pill: "Open Source, Built for India",
    titleLines: [[{ t: "Open Source SOC for Indian SMBs," }], [{ t: "without the enterprise price tag.", accent: true }]],
    description:
      "Our Open Source SOC Model is a ready-to-deploy security operations stack designed specifically for Indian small and medium organizations. It maps directly to the compliance obligations Indian businesses actually face, so a 50-person company can meet the same regulatory bar as a bank, using open-source tooling and a Lanvaus-built framework.",
    primaryCta: CTA_CONTACT,
    secondaryCta: CTA_CAPS,
    image: IMAGES.matrix,
    complianceItems: COMPLIANCE_INDIA,
    ossNote: {
      heading: "A Lanvaus-built product, not a public repository.",
      copy: "We engineered this stack ourselves: the detection content, alerting logic, compliance mappings, dashboards and reporting workflows are all Lanvaus intellectual property, built on open-source foundations so you pay for engineering, not per-seat licences. It is licensed and deployed by us, with support included.",
      demoLabel: "Request a Demo",
      demoTo: "/contact",
      managedLabel: "Want us to run it for you?",
      managedTo: "/services/managed-security",
    },
    stats: [
      { value: "180 days", label: "Log retention (CERT-In requirement)" },
      { value: "6 hours", label: "Incident reporting window (CERT-In)" },
      { value: "₹0", label: "Per-seat commercial SIEM licence fees" },
      { value: "Up to 70%", label: "Lower SOC setup cost vs. commercial tooling" },
    ],
    why: {
      eyebrow: "Why This Matters for Indian SMBs",
      title: { pre: "The regulations apply ", accent: "regardless of company size." },
      paragraphs: [
        "The DPDP Act 2023, CERT-In Cyber Security Directions (2022), the IT Act 2000 and IT Rules, and sector regulations from RBI, SEBI and IRDAI apply to a 50-person company just as they apply to a bank. Log retention, incident reporting timelines and data-protection obligations don't scale down with headcount.",
        "Yet most Indian SMBs have no way to demonstrate compliance today. Commercial SOC tooling is priced for enterprises, and hiring a security team is out of reach. We built the Open Source SOC Model to close that gap with a documented, deployable stack and a compliance framework mapped to Indian law.",
      ],
      image: IMAGES.socCenter,
    },
    risk: {
      eyebrow: "The Business Risk",
      title: { pre: "What non-compliance ", accent: "costs Indian businesses." },
      copy: "Penalties under the DPDP Act, CERT-In non-compliance exposure, loss of enterprise clients who require vendor security attestations, and breach costs that are now the highest in the world.",
      stats: [
        { value: "₹22 crore", text: "Average cost of a data breach in India in 2025, the highest of any country surveyed (IBM Cost of a Data Breach Report 2025)." },
        { value: "₹250 crore", text: "Maximum penalty per instance for failing to implement reasonable security safeguards (DPDP Act 2023, Schedule)." },
        { value: "6 hours", text: "Mandatory window to report cyber incidents to CERT-In (CERT-In Cyber Security Directions, April 2022)." },
        { value: "263 days", text: "Average time to identify and contain a breach in India in 2025 (IBM Cost of a Data Breach Report 2025)." },
      ],
      highlights: [
        "Centralized logging with 180-day retention out of the box",
        "CERT-In incident reporting workflow and templates",
        "DPDP-aligned monitoring of personal data access",
        "Compliance dashboards that serve as audit evidence",
        "Zero per-seat commercial SIEM licence fees, runs on commodity or cloud infrastructure",
        "Vendor security attestation support for enterprise deals",
        "Optional Lanvaus deployment and managed support",
      ],
    },
    audience: {
      title: { pre: "Built for Indian organizations ", accent: "with real obligations and real budgets." },
      copy: "The Open Source SOC Model is designed for small and medium organizations that must meet Indian regulatory requirements without an enterprise security budget or a dedicated security team.",
      cards: [
        { title: "Founders & CEOs of SMBs", note: "Compliance without enterprise spend" },
        { title: "IT Managers wearing the security hat", note: "A documented stack, not a research project" },
        { title: "CA Firms & MSPs", note: "Serve SMB clients with a repeatable model" },
        { title: "Fintech & NBFC Startups", note: "RBI and SEBI expectations" },
        { title: "Healthcare Clinics & Diagnostics Chains", note: "Patient data under DPDP" },
        { title: "EdTech & SaaS Startups", note: "Vendor attestations for enterprise sales" },
      ],
    },
    capabilities: {
      title: { pre: "Everything an Indian SMB ", accent: "needs to demonstrate compliance." },
      cards: [
        { icon: "Database", title: "Centralized Logging & 180-Day Retention", copy: "Collect and retain logs from endpoints, servers, cloud and network for the CERT-In mandated 180 days." },
        { icon: "Crosshair", title: "Threat Detection Rules Tuned for SMBs", copy: "Pre-built detections for the threats small organizations actually face: phishing, credential abuse, ransomware precursors." },
        { icon: "Siren", title: "CERT-In Incident Reporting Workflow", copy: "Case management and templates that get you from detection to a CERT-In report inside the 6-hour window." },
        { icon: "Fingerprint", title: "DPDP-Aligned Data Access Monitoring", copy: "Visibility into who accesses personal data, supporting DPDP Act safeguards and breach notification duties." },
        { icon: "LayoutDashboard", title: "Compliance Dashboards & Audit Evidence", copy: "Dashboards mapped to DPDP, CERT-In, IT Act and sector rules that double as audit evidence." },
        { icon: "Laptop", title: "Endpoint & Cloud Visibility", copy: "Agent-based endpoint monitoring plus cloud audit log ingestion for a complete picture of your estate." },
      ],
    },
    methodology: {
      title: { pre: "From zero to ", accent: "compliance-ready operations." },
      copy: "Lanvaus deploys and configures the full stack in your environment, then hands it over to your team or keeps operating it for you.",
      steps: [
        { title: "Assess", copy: "Identify which Indian regulations apply to you, inventory systems and confirm what evidence you need to produce." },
        { title: "Design", copy: "Size the stack for your environment and select the compliance control mappings that apply to your sector." },
        { title: "Deploy", copy: "We install the stack on-premises or in cloud, onboard log sources and load our detection and alerting content." },
        { title: "Operate", copy: "Run it with your IT team using our operations guide and training, or add Lanvaus managed support." },
      ],
    },
    deliverables: [
      { icon: "GitBranch", title: "Deployable SOC Stack", copy: "Our licensed, version-controlled stack deployed on-premises or in your cloud." },
      { icon: "Scale", title: "Indian Compliance Control Mapping", copy: "DPDP, CERT-In, IT Act and RBI/SEBI/IRDAI mappings as applicable." },
      { icon: "Library", title: "Pre-built Detection & Alert Set", copy: "Lanvaus-authored detections and alerting tuned for SMB threat profiles." },
      { icon: "FileSignature", title: "CERT-In Incident Reporting Templates", copy: "Ready-to-fill templates for the 6-hour reporting requirement." },
      { icon: "LayoutDashboard", title: "Compliance Dashboard Pack", copy: "Audit-evidence dashboards for each applicable regulation." },
      { icon: "BookOpenCheck", title: "Deployment & Operations Guide", copy: "Step-by-step deployment and day-two operations documentation." },
      { icon: "HeartHandshake", title: "Optional Lanvaus Managed Support", copy: "Add monitoring, tuning and response from the Lanvaus team." },
    ],
    stack: {
      title: { pre: "Built entirely on ", accent: "proven open-source tooling." },
      copy: "Every component is open source, widely deployed and actively maintained, so you pay for Lanvaus engineering and support rather than per-seat licences, with no vendor lock-in.",
      badges: ["Wazuh", "Elastic", "Suricata", "TheHive", "Grafana", "OpenSearch"],
    },
    isProduct: true,
    complianceMatrix: {
      eyebrow: "Indian Compliance Mapping",
      title: { pre: "Every Indian requirement, ", accent: "mapped to a working control." },
      copy: "This is the table CTOs and compliance officers ask us for. Each obligation below is met by a component that ships pre-configured in the product, not by a recommendation in a document.",
      columns: ["Requirement", "Source", "How the product addresses it"],
      rows: [
        [
          "Retain ICT system logs for 180 days, within India",
          "CERT-In Directions, April 2022 (clause on log retention)",
          "OpenSearch / Elastic tier sized for a rolling 180 days, deployed in your Indian region or on-premises, with retention policy pre-set and integrity alerting on log-source loss.",
        ],
        [
          "Report specified cyber incidents within 6 hours of noticing",
          "CERT-In Directions, April 2022 (clause on incident reporting)",
          "TheHive case template pre-filled with organisational details, incident classification picker, evidence attachment and an approval step, so detection to submission fits the window.",
        ],
        [
          "Synchronise all system clocks to NIC / NPL time servers",
          "CERT-In Directions, April 2022 (clause on time synchronisation)",
          "NTP configuration baseline applied at deployment plus a drift monitor that alerts when any host falls outside tolerance.",
        ],
        [
          "Maintain a designated point of contact for CERT-In",
          "CERT-In Directions, April 2022",
          "Point-of-contact record and escalation matrix built into the runbook, surfaced on the incident dashboard so the on-call analyst always knows who signs.",
        ],
        [
          "Implement reasonable security safeguards for personal data",
          "DPDP Act 2023, s.8(4)",
          "Endpoint and server monitoring, access-control alerting, and a documented control set you can produce as evidence of safeguards actually operating.",
        ],
        [
          "Detect and notify personal data breaches",
          "DPDP Act 2023, s.8(6)",
          "Detection rules for personal-data access anomalies and exfiltration patterns, with a breach-assessment playbook and notification template.",
        ],
        [
          "Reasonable security practices for sensitive personal data",
          "IT Act 2000 s.43A and SPDI Rules 2011",
          "Control mapping to ISO 27001 Annexure A, which the SPDI Rules recognise, with dashboards evidencing each mapped control.",
        ],
        [
          "Sector cyber-security framework, monitoring and audit trails",
          "RBI / SEBI / IRDAI frameworks (as applicable)",
          "Pre-built dashboards and reports aligned to sector expectations for monitoring coverage, audit trails, incident handling and periodic review.",
        ],
      ],
      footnote:
        "Regulatory references were accurate at the time of writing and are summarised for engineering planning; they are not legal advice. We map controls, your counsel confirms applicability.",
    },
    spec: {
      eyebrow: "Technical Specification",
      title: { pre: "What gets deployed in ", accent: "your environment." },
      copy: "The product runs entirely inside your infrastructure. You hold the data, the keys and the platform; we hold the engineering and the support commitment.",
      items: [
        { label: "Deployment model", value: "On-premises, private cloud or your VPC", note: "Docker Compose for single-node, or Kubernetes / multi-node for HA. Air-gapped installs supported." },
        { label: "Reference sizing (SMB)", value: "8 vCPU · 32 GB RAM · 2 TB", note: "Handles roughly 150-300 endpoints at 180-day retention; scaled per event-per-second estimate." },
        { label: "Telemetry collection", value: "Agent + syslog + cloud audit", note: "Wazuh agents on endpoints and servers, syslog for network devices, native connectors for Azure, AWS and GCP audit logs." },
        { label: "Network detection", value: "Suricata IDS with curated rule set", note: "Deployed inline or on a SPAN/mirror port with tuned rules for SMB threat profiles." },
        { label: "Detection content", value: "Lanvaus-authored rule pack", note: "MITRE ATT&CK-mapped detections for phishing, credential abuse, ransomware precursors, insider access and cloud misuse." },
        { label: "Case management", value: "TheHive with our playbooks", note: "Incident templates, severity model, evidence handling and the CERT-In reporting workflow pre-loaded." },
        { label: "Dashboards", value: "Grafana compliance pack", note: "One dashboard per regulation plus an executive posture view, all exportable as audit evidence." },
        { label: "Data residency", value: "100% within your tenancy", note: "No telemetry leaves your environment. Lanvaus support access is time-bound, logged and revocable." },
        { label: "Updates & support", value: "Quarterly content updates", note: "New detections, rule tuning and compliance mapping updates under the support subscription." },
      ],
    },
    pricing: {
      eyebrow: "Packaging",
      title: { pre: "Three ways to ", accent: "own this." },
      copy: "Licensed per deployment, not per seat. Pricing depends on estate size, retention and whether you want us in the operating seat, so we quote after a short scoping call rather than publishing a number that would be wrong for you.",
      tiers: [
        {
          name: "Deploy",
          for: "You run it",
          copy: "We deploy and configure the full stack in your environment, load our detection content and compliance mappings, train your team and hand it over.",
          features: [
            "Full stack deployed in your environment",
            "Lanvaus detection and alerting content pack",
            "Indian compliance control mapping and dashboards",
            "CERT-In reporting workflow and templates",
            "Deployment and operations documentation",
            "Two training sessions for your IT team",
            "12 months of content updates",
          ],
        },
        {
          name: "Deploy + Support",
          for: "You run it, we back you",
          featured: true,
          copy: "Everything in Deploy, plus a Lanvaus engineer on call for tuning, detection questions and incident escalation, so your IT generalist is never alone with an alert.",
          features: [
            "Everything in Deploy",
            "Quarterly detection tuning and health review",
            "Business-hours escalation channel to a Lanvaus engineer",
            "Incident advisory support, including CERT-In report review",
            "Monthly posture report prepared for you",
            "Annual tabletop exercise",
            "Priority content updates",
          ],
        },
        {
          name: "Fully Managed",
          for: "We run it",
          copy: "We operate the platform inside your environment as a managed SOC: monitoring, triage, response and reporting handled by the Lanvaus team under agreed SLAs.",
          features: [
            "Everything in Deploy + Support",
            "24 x 7 monitoring and triage by Lanvaus analysts",
            "Incident response under contractual SLAs",
            "Threat hunting and purple-team validation",
            "Compliance evidence pack prepared monthly",
            "Named service manager and quarterly business review",
            "Upgrade path to enterprise SIEM if you outgrow the stack",
          ],
        },
      ],
      note:
        "All tiers are licensed commercial products. The underlying components are open source, which removes per-seat platform licence fees, but the detection content, compliance mappings, dashboards, reporting workflows and documentation are Lanvaus intellectual property and are licensed, not published.",
    },
    resources: [
      { badge: "Free Whitepaper", icon: "BookOpen", title: "Indian SMB Cybersecurity Compliance Guide: DPDP, CERT-In and Sector Rules", copy: "What each regulation requires, who it applies to and how an open-source SOC helps you evidence it." },
      { badge: "Free Checklist", popular: true, icon: "ClipboardCheck", title: "CERT-In Directions Readiness Checklist", copy: "Log retention, time synchronization, incident reporting and point-of-contact requirements in one checklist." },
    ],
    closing: {
      title: { pre: "Ready for enterprise-grade security ", accent: "at SMB cost?" },
      copy: "Talk to a Lanvaus engineer about deploying the Open Source SOC Model in your organization, or having us run it for you.",
      secondary: { label: "Back to Services", to: "/services" },
    },
  },
};

export const SERVICE_ORDER = [
  "/services/vapt",
  "/services/managed-security",
  "/services/solutions",
  "/services/open-source-soc",
];

export const ALL_SERVICE_PAGES = [
  "/services/vapt",
  "/services/managed-security",
  "/services/enterprise-landing-zone",
  "/services/enterprise-siem",
  "/services/enterprise-xdr",
  "/services/cloud-security",
  "/services/open-source-soc",
];
